import React from 'react'
import {useMatch,useLocation,useNavigate} from 'react-router'

export const Match = ({ path, children }) => {
  let match = useMatch(path);
  let location = useLocation();
  let navigate = useNavigate();
  return children({ match, location, navigate });
}